import type { StyleProp, ViewStyle } from "react-native";
import { Text, type TextProps } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Box from "../Box";

export type CustomListSubheaderProps = {
	enableGutters?: boolean;
	children: React.ReactNode;
	font?: string;
	adjustsFontSizeToFit?: boolean;
	style?: StyleProp<ViewStyle>;
	textVariant?: TextProps<Text>["variant"];
	dense?: boolean;
};

export const CustomListSubheader = ({
	children,
	enableGutters = true,
	adjustsFontSizeToFit = false,
	textVariant = "titleSmall",
	dense = false,
	...rest
}: CustomListSubheaderProps) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();
	const densePaddingTop = isMobile ? 0 : 8;

	return (
		<Box
			paddingHorizontal={enableGutters ? 16 : 0}
			gap={16}
			style={{
				paddingTop: dense ? densePaddingTop : 18,
				paddingBottom: dense ? 8 : 18,
			}}
			{...rest}
		>
			<Text
				adjustsFontSizeToFit={adjustsFontSizeToFit}
				style={{ color: theme.colors.onSurface }}
				variant={textVariant}
			>
				{children}
			</Text>
		</Box>
	);
};
